const PARAM_REGEX = /\{([^}]+)\}/g;

export function extractPathParams(endpoint) {
    const matches = [...(endpoint.path || "").matchAll(PARAM_REGEX)];
    if (matches.length === 0) return [];
    const declared = (endpoint.parameters || []).filter((p) => p.in === "path");
    return matches.map((m) => {
        const name = m[1];
        const dp = declared.find((p) => p.name === name);
        const schema = dp?.schema || {};
        return {
            name,
            testValue: dp?.testValue || schema.example || schema.default || "",
            needsUser: dp?.testValue === "__ASK_USER__" || (!dp?.testValue && !schema.example && !schema.default),
            schema,
        };
    });
}

export function extractQueryParams(endpoint) {
    return (endpoint.parameters || []).filter((p) => p.in === "query").map((p) => {
        const schema = p.schema || {};
        return {
            name: p.name,
            required: !!p.required,
            testValue: p.testValue || schema.default || schema.example || "",
            schema,
        };
    });
}

export function substitutePath(path, paramValues) {
    let result = path;
    for (const [name, value] of Object.entries(paramValues)) {
        result = result.replace(`{${name}}`, encodeURIComponent(value));
    }
    return result;
}

export function extractGraphQLArgs(endpoint) {
    return (endpoint.parameters || []).filter((p) => p.in === "argument").map((p) => {
        const schema = p.schema || {};
        return {
            name: p.name,
            required: !!p.required,
            testValue: p.testValue || schema.default || "",
            needsUser: p.testValue === "__ASK_USER__" || (!p.testValue && !schema.default),
            schema,
        };
    });
}

export function buildQueryString(queryParams, paramValues) {
    const parts = [];
    for (const qp of queryParams) {
        const val = paramValues?.[qp.name] ?? qp.testValue;
        if (val != null && val !== "") parts.push(`${encodeURIComponent(qp.name)}=${encodeURIComponent(val)}`);
    }
    return parts.length > 0 ? `?${parts.join("&")}` : "";
}
